import { FlowsWrapper } from "./flows-wrapper";

export default function FlowsPage() {
  return <FlowsWrapper />;
}
